import CreateDataRetrievalBegunAction from "./CreateDataRetrievalBegunAction";
import CreateDataRetrievalEndedAction from "./CreateDataRetrievalEndedAction";

import { GET } from "../adapters/xhr";

export default function () {
    return (dispatch) => {
        dispatch(CreateDataRetrievalBegunAction());

        const url = "api/EquipmentTypeCategory/GetAllForDropdown";
        
        GET(url)
            .then(function (response) {
                if (response.status === 200) {
                    dispatch({
                        type: "EQUIPMENT_TYPE_CATEGORIES_RETRIEVED",
                        equipmentTypeCategories: response.data
                    });
                }

                dispatch(CreateDataRetrievalEndedAction());
            }).catch(function (response) {
                dispatch(CreateDataRetrievalEndedAction());
            });
    };
}
